// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalLoading_backdrop__1Agx1"};